import React from 'react';
import { faction1, faction2 } from '../Assets';

const Factions = () => {
  return (
    <div className="w-full max-w-screen-xl mx-auto px-4 md:px-10 py-20 text-white">
      <h2 className="text-3xl font-semibold uppercase text-right mb-6">The Factions of Molundra</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <img
            src={faction1}
            alt="Faction 1"
            className="w-full h-auto sm:h-72 md:h-96 object-cover rounded-md"
          />
        </div>
        <div>
          <img
            src={faction2}
            alt="Faction 2"
            className="w-full h-auto sm:h-72 md:h-full object-cover rounded-md"
          />
        </div>
      </div>
    </div>
  );
};

export default Factions;